export default (
	props,
	{ story: { duration, format, shortName, programName } },
) => {
	return {
		format,
		duration,
		shortName: shortName && shortName.trim(),
		programName,
	};
};
